export enum UserRoles {
  admin = 'admin',
}

export type BaseProfile = {
  role: UserRoles
  token: string
}

export enum AuthProviderEnum {
  Google = 'Google',
  Microsoft = 'Microsoft',
}

export type CurrentUser = BaseProfile | null
